(() => {
  const SELECTOR =
    "[data-ineffable-invitation]";

  function initializeInvitation(section) {
    if (
      !section ||
      section.dataset.invitationInitialized === "true"
    ) {
      return;
    }

    section.dataset.invitationInitialized =
      "true";

    const card =
      section.querySelector(
        "[data-invitation-reveal]"
      );

    if (!card) {
      return;
    }

    const reveal = () => {
      card.classList.add(
        "is-visible"
      );
    };

    if (
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches
    ) {
      reveal();
      return;
    }

    if (
      !(
        "IntersectionObserver" in
        window
      )
    ) {
      reveal();
      return;
    }

    const observer =
      new IntersectionObserver(
        (entries) => {
          entries.forEach(
            (entry) => {
              if (
                !entry.isIntersecting
              ) {
                return;
              }

              reveal();

              observer.disconnect();
            }
          );
        },
        {
          threshold: 0.12,
          rootMargin:
            "0px 0px -7% 0px"
        }
      );

    observer.observe(
      section
    );
  }

  function initializeAll(
    root = document
  ) {
    root
      .querySelectorAll(
        SELECTOR
      )
      .forEach(
        initializeInvitation
      );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      () => initializeAll()
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      const section =
        event.target.matches?.(
          SELECTOR
        )
          ? event.target
          : event.target
              .querySelector?.(
                SELECTOR
              );

      if (!section) {
        return;
      }

      section.dataset
        .invitationInitialized =
        "false";

      initializeInvitation(
        section
      );
    }
  );
})();